export const DATE_PRESET_OPTIONS = [
  { value: "30min", label: "Last 30 minutes" },
  { value: "1hour", label: "Last 1 hour" },
  { value: "12hour", label: "Last 12 hours" },
  { value: "24hour", label: "Last 24 hours" },
  { value: "custom", label: "Custom" },
] as const;
